// Node
import noUiSlider from 'nouislider';
import * as React from 'react';

export default class PricesRange extends React.Component {
  constructor(props) {
    super(props);
    this.INITIAL_MAX_END = 7000000;
    this.interacted = false;
    this.slider = null;
    this.start = this.props.prices[0] ?? 0;
    this.end = this.props.max_end;
    this.interaction = this.interaction.bind(this);
    this.render = this.render.bind(this);
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
    this.handleEndBlur = this.handleEndBlur.bind(this);
    this.handleStartBlur = this.handleStartBlur.bind(this);
    this.calcEnd = this.calcEnd.bind(this);
    this.filter = this.filter.bind(this);
    this.state = {
      prices_start: this.props.prices[0] ?? 0,
      prices_end: this.props.prices[1] ?? this.calcEnd(this.props),
    };
  }

  filter(newPrices) {
    const maxEnd = this.props.max_end || this.INITIAL_MAX_END;
    if (maxEnd <= newPrices[1]) newPrices[1] = this.INITIAL_MAX_END;
    this.props.filter(this.props.filterValue, newPrices);
  }

  calcEnd(props) {
    return Math.min(
      props.prices[1] ?? this.INITIAL_MAX_END,
      props.max_end ?? this.INITIAL_MAX_END,
      this.INITIAL_MAX_END
    );
  }

  componentDidMount() {
    // Создаем слайдер.
    // min и max должны отличаться
    this.slider = noUiSlider.create(document.getElementById(`${this.props.filterValue}Slider`), {
      start: [this.start, this.calcEnd(this.props)],
      connect: true,
      animation: true,
      step: 500,
      range: {
        min: 0,
        max: this.end,
      },
    });

    let component = this;
    // Обновляем
    // инпут только во время перетягивания слайдера.
    this.slider.on('update', function (values, handle) {
      document.getElementById(`${component.props.filterValue}SliderStart`).value = Math.floor(values[0]);
      document.getElementById(`${component.props.filterValue}SliderEnd`).value = Math.floor(values[1]);
    });

    this.slider.on('change', function (values, handle) {
      component.filter([Math.floor(values[0]), Math.floor(values[1])]);
    });

    this.slider.on('start', function () {
      component.interaction();
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.max_end != this.props.max_end ||
      this.props.prices[0] != nextProps.prices[0] ||
      this.props.prices[1] != nextProps.prices[1] ||
      nextState.prices_start != this.state.prices_start ||
      nextState.prices_end != this.state.prices_end
    );
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.max_end !== this.props.max_end) {
    //   let values = this.slider.get();
    //   if (this.props.initPrices.length === 0 || this.props.initPrices[1] > nextProps.max_end) {
    //     this.slider.set([values[0], this.calcEnd(nextProps)]);
    //     document.getElementById(`${this.props.filterValue}SliderEnd`).value = nextProps.max_end;
    //   }
    // }
    if (
      this.props.prices[0] != nextProps.prices[0] ||
      this.props.prices[1] != nextProps.prices[1] ||
      nextProps.max_end != this.props.max_end
    ) {
      this.slider.set([nextProps.prices[0], this.calcEnd(nextProps)]);
      this.setState({ prices_start: nextProps.prices[0], prices_end: this.calcEnd(nextProps) });
    }
  }

  // Взаимодействовали со слайдером
  interaction() {
    if (this.props.distanceInteraction != null) {
      this.props.distanceInteraction();
    }
    this.interacted = true;
  }

  // После ввода значения в инпут сохраняем его, перетаскиваем слайдер и сортируем базы.
  handleStartChange(event) {
    let value = event.target.value.replace(/\D/g, '');
    let numValue = parseInt(value);
    const maxEnd = this.props.max_end || this.INITIAL_MAX_END;

    if (isNaN(numValue)) {
      this.setState({ prices_start: '' });
      return;
    }

    if (numValue > maxEnd) {
      numValue = maxEnd;
    }

    this.setState({ prices_start: numValue });
  }

  handleStartBlur(event) {
    let value = event.target.value.replace(/\D/g, '');
    const numValue = parseInt(value || 0);

    const numLastValue = this.state.prices_end;
    const oldFirstValue = this.props.prices[0] ?? 0;
    if (oldFirstValue == numValue) return;

    if (numValue > numLastValue) {
      this.slider.set([numLastValue, numLastValue]);
      this.filter([numLastValue, numLastValue]);
    } else {
      this.slider.set([numValue, numLastValue]);
      this.filter([value, numLastValue]);
    }
  }

  // После ввода значения в инпут сохраняем его, перетаскиваем слайдер и сортируем базы.
  handleEndChange(event) {
    const value = event.target.value.replace(/\D/g, '');
    let numValue = parseInt(value);
    const maxEnd = this.props.max_end || this.INITIAL_MAX_END;

    if (isNaN(numValue)) {
      this.setState({ prices_end: '' });
      return;
    }

    if (numValue > maxEnd) {
      numValue = maxEnd;
    }

    this.setState({ prices_end: numValue });
  }

  handleEndBlur(event) {
    const maxEnd = this.props.max_end || this.INITIAL_MAX_END;
    const value = event.target.value.replace(/\D/g, '');
    const numValue = parseInt(value || maxEnd);

    const numFirstValue = this.state.prices_start ?? 0;
    const oldLastValue = this.props.prices[1];
    if (numValue == oldLastValue) return;
    console.log(maxEnd);

    if (numValue < numFirstValue) {
      this.slider.set([numFirstValue, numFirstValue]);
      this.filter([numFirstValue, numFirstValue]);
    } else if (numValue > maxEnd) {
      this.slider.set([numFirstValue, maxEnd]);
      this.filter([numFirstValue, maxEnd]);
    } else {
      this.slider.set([numFirstValue, numValue]);
      this.filter([numFirstValue, numValue]);
    }
  }

  isDefaultStart() {
    return !this.interacted && !this.state.prices_start;
  }

  isDefaultEnd() {
    return !this.interacted && this.state.prices_end === this.calcEnd(this.props);
  }

  render() {
    this.slider?.updateOptions({
      range: {
        min: 0,
        max: this.props.max_end || this.INITIAL_MAX_END,
      },
    });
    return (
      <div className='filter-row'>
        <div className='filter-row__title'>{this.props.title}</div>
        <div className='pick-line pick-line-prices pick-line-one'>
          <div className='pick-input'>
            <div className='pick-input__box'>
              <span className='pick-input__box-label'>От</span>
              <input
                type='text'
                id={`${this.props.filterValue}SliderStart`}
                defaultValue={this.start}
                value={this.state.prices_start}
                className='pick-price-input'
                onChange={this.handleStartChange}
                onBlur={this.handleStartBlur}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                style={{ color: this.isDefaultStart() ? '#0000007A' : 'initial' }}
              />
              <span className='pick-input__box-currency'>₽</span>
            </div>
          </div>
          <div className='pick-input'>
            <div className='pick-input__box'>
              <span className='pick-input__box-label'>До</span>
              <input
                type='text'
                id={`${this.props.filterValue}SliderEnd`}
                defaultValue={this.end}
                value={this.state.prices_end}
                className='pick-price-input'
                onChange={this.handleEndChange}
                onBlur={this.handleEndBlur}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                style={{ color: this.isDefaultEnd() ? '#0000007A' : 'initial' }}
              />
              <span className='pick-input__box-currency'>₽</span>
            </div>
          </div>
        </div>
        <div className='pick-line pick-line-one pick-line-prices-slider'>
          <div id={`${this.props.filterValue}Slider`} />
        </div>
      </div>
    );
  }
}
